import Telemetry, { createLogBackend, createMetalBackend, createReactUFOBackend, createSentryBackend, initTelemetry, Observers } from '@atlassian/mpac-telemetry';
import { DOMUtils } from '@atlassian/mpac-utils';
import { getCLS, getFCP, getFID, getLCP, getTTFB } from 'web-vitals';
import createRouteTransitionBackend from './createRouteTransitionBackend';
const {
  getNetworkRequestTimes,
  waitForTimeToInteractive,
  PageVisibilityObserver
} = Observers;

// Start listening for page visibility change so we can
// differentiate foreground events from background events later
PageVisibilityObserver.start();
async function initEmceeTelemetry(config, SPI, emceeVersion, onRouteTransitionEnd) {
  let subProduct;
  try {
    const hostInfo = await SPI.getHostInfo();
    subProduct = hostInfo.subproduct || hostInfo.product;
  } catch (error) {
    subProduct = 'SUBPRODUCT_UNKNOWN';
    console.error('Error fetching product for telemetry', error);
  }
  const metalBackend = createMetalBackend({
    env: config.env,
    id: config.id,
    version: emceeVersion,
    synthetic: DOMUtils.isSynthetic(),
    subProduct
  });
  const sentryBackend = createSentryBackend();
  const logBackend = createLogBackend({
    enabled: false
  });
  const reactUFOBackend = createReactUFOBackend({
    isBot: false
  }); // EMCEE is always behind login flow, therefore not a bot
  const routeTransitionBackend = createRouteTransitionBackend({
    onRouteTransitionEnd
  });
  initTelemetry([metalBackend, sentryBackend, logBackend, routeTransitionBackend, reactUFOBackend]);
}
export default _ref => {
  let {
    emceeContainer,
    config,
    SPI,
    emceeVersion,
    onRouteTransitionEnd
  } = _ref;
  if (!emceeContainer) {
    console.error('Did not find the root container, complete telemetry will not be sent');
  }
  initEmceeTelemetry(config, SPI, emceeVersion, onRouteTransitionEnd);
  getFCP(_ref2 => {
    let {
      value
    } = _ref2;
    return Telemetry.timeToFirstPaint(value);
  });
  getLCP(_ref3 => {
    let {
      value
    } = _ref3;
    return Telemetry.timeToLargestContentfulPaint(value);
  });
  getTTFB(_ref4 => {
    let {
      value
    } = _ref4;
    return Telemetry.timeToFirstByte(value);
  });
  getFID(_ref5 => {
    let {
      value
    } = _ref5;
    return Telemetry.firstInputDelay(value);
  });

  // Measured only when page is hidden / unloaded
  getCLS(_ref6 => {
    let {
      value
    } = _ref6;
    return Telemetry.cumulativeLayoutShift(value);
  });
  if ('Promise' in window && 'PerformanceObserver' in window && 'PerformanceLongTaskTiming' in window && 'PerformancePaintTiming' in window && emceeContainer) {
    waitForTimeToInteractive(emceeContainer).then(tti => {
      Telemetry.timeToInteractive(tti);
      const requestTransferTimes = getNetworkRequestTimes([/marketplace.*atlassian.com/, /atlastunnel.com/, /algolianet.com/], []);
      requestTransferTimes.forEach(requestGroup => Telemetry.resourceDownloadTime(requestGroup.type, requestGroup.duration));
    }).catch(console.error.bind(console));
  }
};